import SwipeInterceptPanResponder from '@components/SwipeInterceptPanResponder';

export default SwipeInterceptPanResponder;
